import React from 'react';
// import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { history }  from '../routers/AppRouter';
import isEmail from 'validator/lib/isEmail';
import isEmpty from 'lodash/isEmpty';
// import format from 'date-fns/format';
import { clearPicAppError } from '../actions/picapp';
import { startGetParticipants } from '../actions/participants';
import { startAddNewParticipant } from '../actions/participants';
import { startDeleteParticipants } from '../actions/participants';
import { startUpdateParticipantList } from '../actions/participants';
import { updateParticipants } from '../actions/participants';
import { updateContacts } from '../actions/contacts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import PicContactsAutoSuggest from './PicContactsAutosuggest';
// import PicPostRequest from '../apis/PicPostRequest';
// import PicPutRequest from '../apis/PicPutRequest';
import { upperCaseFirst } from '../utils/strUtils';
// import { LessThanIcon } from './icons/LessThanIcon';
import { Title } from './Title';
import { ShadowButton }  from './buttons/ShadowButton';
import { SimpleButton }  from './buttons/SimpleButton';
import { PencilIcon } from './icons/PencilIcon';
import { TrashIcon } from './icons/TrashIcon';
import { HomeIcon } from './icons/HomeIcon';

// JSX used to construct a row; If date is less that 8 characters means it string "Not Sent".
// If greater that 8 characters, its the ISODate. This formats it as short date.
// const InviteRow = ({email, name, sentdate, isChecked, handler}) => (
//     <div className="invites-row-people-page">
//         <div className="col01">
//           <input  className="invites-row-checkbox"
//               value={email}
//               type="checkbox"
//               checked={isChecked || false}
//               onChange={handler}
//           />
//         </div>
//         <div className="col02">{email}</div>
//         <div className="col03">{name}</div>
//         <div className="col04"></div>
//     </div>
// );

// JSX used to construct a row; If date is less that 8 characters means it string "Not Sent".
// If greater that 8 characters, its the ISODate. This formats it as short date.
const InviteRow = ({email, name, sentdate, isChecked, handler}) => (
  <div className="invites-row-people-page">
      <div className="col01">
           <div className="invites-header-col1-spacer"> &nbsp;</div>
      </div>
      <div className="col02">{email}</div>
      <div className="col03">{name}</div>
      <div className="col04"></div>
  </div>
  );

// JSX used to construct checkbox at column heading (selects all)
// const InviteCheckBoxHeader = ({checked, handler}) => (
//   <div className="col01">
//       <input  className="invites-header-checkbox"
//           id="checkboxheader"                    
//           value="yes"
//           name="user1"
//           type="checkbox"
//           checked={checked}
//           onChange={handler}
//       />
//   </div>
// );

// JSX used to replace checkbox that was originally here with spacer
const InviteCheckBoxHeader = ({checked, handler}) => (
  <div className="pcol01">
      <div className="people-header-col1-spacer"> &nbsp;</div>
  </div>
);

  
  /*
    Parent Component: this component ;  renders autosuggest input bar and the particpant table list.
           It also provides sort capabilty for email and name.
           When a user clicks the Plus Icon on the input bar,  the following happens: 
              - the entry is added on the particant list in redux store with disposition of "new" OR
              - if plus sign is clicked in response to an edit action (edit icon), entry will be replaced in redux store. 
              - it then clears the input field in the input bar
           When user clicks delete icon, the following happens:
              - The entry remains on list but performs a logical delete (marks entry with dispostion of "delete").
                The logical delete is enough for it not to longer appear on screen
    Child  Component: PicContactsAutsuggest;  this provides two input fields with autosuggest capability.
           Note, the source of the truth for emailValue and nameValue, is this parent component . This parent passes down
           function props (setParentComponentValues, onChangeField1Handler and onChangeField2Handler), so child can update
           emailValue and nameValue here (on parent).
    inputs:  - (from redux store/mapStateToProps) list of existing participants, set at initialization time 
             - (from function prop) emailValue and nameValue passed up from PicContactsAutosuggest component via the
               setParentComponentValues function prop, onChangeField1Handler and onChangeField2Handler
             - (from mapDispatchToProps) clearPicAppError function, used to clear errors on store once resolved
    outputs: - render input bar containing autosuggest component for email and name 
             - updated list of participants in redux store.
             - Make api call with array of participants along with their dispositions and addToContacts flag.
               API will construct a delete list and a list of new participants that should be added to contacts.
               Finally api will construct list of new and existing, replace participant list document on mongodb,
               run delete contacts, then run add new contacts.
               NOTE: when user hits Save or Save/Next, the client must perform physical delete of items with 
                     disposition of delete, and change all other dispostions to existing.
               
  */
class PicPeople extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        // participants: participantList,      // this particants for an event. The check box status for individual rows is maintained in this array 
        // participants: [],      // this particants for an event. The check box status for individual rows is maintained in this array 
        checkAll: false,           // check box status for "Check All"
        emailValue: '',            // both emailValue and nameValue is set when a suggestion is selected
        nameValue: '',             // from either the email input field or name input field
        prevEmailValue: '',        // used by addNewParticipant edit logic to compare previous values with changed values
        prevNameValue: '',         // used by addNewParticipant edit logic to compare previous values with changed values    
        prevDisposition: '',       // used by addNewParticipant to see if previous value was existing.
        editParticipant: false,    // set to true when editing a participant item
        editIndex: 0,              // set index value when editing a participant item
        childFunction: '',         // Function provided by PicContactsAutosuggest to be able to clear input fields
        emailSortAsc:  true,
        nameSortAsc:   true,
        dateSortAsc:   true,
        formError: ''
      };
    }
    
    // ****************************************************************** */
    // Lifecycle Methods
    // ****************************************************************** */

    componentDidMount() {
      // console.log("MOUNTED COMPONENT PIC PEOPLE ");
      /* obtain the active event */
      let eventInfoObject = this.props.event.active;

      /* Initialize redux store with participant list for active event */
      this.props.startGetParticipants("PicPeople");
    }


    componentWillUnmount() {
      if (this.props.picapp.error) {
        this.props.clearPicAppError();
      }
    }

    // ****************************************************************** */
    // Specialty functions for componennt to component interaction 
    // ****************************************************************** */

    // This function is passed down to the PicContactsAutosuggest component. The PicContactsAutosuggest
    // component calls this function to pass up the email and name value that were set on the Autosuggest component.
    // This function will then set the values so we can render it on this page.
    setParentComponentValues = (emailValue, nameValue) => {
      this.setState({ emailValue, nameValue });
    };

    // This function is passed as a function prop to the PicContactsAutoSuggest child component, 
    // within the render function. The purpose of passing it down is for the PicContactsAutoSuggest 
    // component to let this parent component know what function to call when it needs to clear input fields.
    // The function provided will be saved in local state and called to clear the input field
    // everytime user adds a new participant (handleAddNewParticipant)
    // getChildFunction = (childFunction) => {
    //   this.setState({childFunction})
    // }
    

    // ****************************************************************** */
    // Handlers 
    // ****************************************************************** */

    /* These 2 function props get passed to child component in order to manage 
       emailValue and nameValue here (the parent) */
    onChangeField1Handler = (inputField1) => {
      this.setState({emailValue: inputField1})
    }

    onChangeField2Handler = (inputField2) => {
      this.setState({nameValue: inputField2})
    }

    // handleCheckBoxAll = () => {

    //   let { list } = this.props.participants;

    //   this.setState((state) => {
    //           let checkAll = !state.checkAll        // toggle true/false state
    //           list.forEach(participant => { participant.isChecked = checkAll;}) // change on all 
    //           return {checkAll};
    //   })
    // };

    // handleCheckBoxSingle = (event) => {

    //   let { list: participants }  = this.props.participants;

    //   // get index value for target email
    //   let targetEmail = event.target.value;

    //   // create a new participant list and assign the modified participant object
    //   let participantsCopy = [...participants];
    //   let indexFound = participantsCopy.findIndex((participant) => {return (participant.email === targetEmail)})
    //   let foundParticipant = participantsCopy[indexFound];
    //   foundParticipant.isChecked = !foundParticipant.isChecked;
    //   participantsCopy[indexFound] = foundParticipant;

    //   // set the state using modified participant list
    //   // this.setState({participants: modifiedParticipantList})
    //   this.props.updateParticipants(participantsCopy) ;
    // }


    /* Note that this method handles both add and edit participant entry */
    handleAddNewParticipant = () => {

      console.log("INSIDE ADD NEW PARTICAPANT")

      let { active: activeEvent } = this.props.event;
      
      /* If no event is active, let user know */
      if (isEmpty(activeEvent) ) {
         this.setState({formError: "Action required: select or create an event before adding participants:yes"});
         return;
      }
     
      if (this.isFormValidated()) {
          /* split name and convert first characters to upper case */
          let fullname = this.state.nameValue.split(' ');        
          let firstName = upperCaseFirst(fullname[0]).trim();
          let lastName  = upperCaseFirst(fullname[1]).trim();  
         
          /* lets initialize flag, that tells us to add participant to contacts collection 
             based on whether participant already exist in the contacts collection */
          let addToContacts = this.existInContacts(this.state.emailValue) ? 'no' : 'yes';

          console.log("ADD TO CONTACTS ", addToContacts);
          
          /* make copy of participants array*/
          let participantsCopy = []; 
          if (this.props.participants.list) {  
            participantsCopy = [...this.props.participants.list];
          } 

          /* Here we check if we are adding new participant or editing one on list */
          console.log("Checking if update or add")
          if (this.state.editParticipant) {
            console.log("This is an update")
            /* Here we are editing existing entry based on the state.editIndex value set by handleEdit. 
               Note, that after editing existing value, new entry may be created for previous values with
               a disposition of delete, so api can delete in the event it previously existed.*/
            
            /* Edit current index entry as new */          
            participantsCopy[this.state.editIndex].email = this.state.emailValue;
            participantsCopy[this.state.editIndex].name  = this.state.nameValue;
            participantsCopy[this.state.editIndex].disposition = "new";
            participantsCopy[this.state.editIndex].addToContacts = addToContacts;

            /* If new email value (dispostion = "new") has changed, and previous value was existing,  then create new entry in 
               redux store with previous values and disposition of "delete", so next call to api, will 
               delete that entry from contacts. */
            let { emailValue: newEmailValue, prevEmailValue, prevNameValue, prevDisposition } = this.state;

            if ((newEmailValue !== prevEmailValue) && (prevDisposition === "existing")) {
              /* add new entry with previous values to end of array for delete upon next api call */
               participantsCopy.push({
                email: prevEmailValue,
                name:  prevNameValue,
                sentDate: null, 
                attend: false,
                disposition: "delete", 
                addToContacts: "no"
              });
            }
          } else {
              console.log("This is an add")
              /* Here we a adding new participant. If email is not already in list, just add to front of array.
                 If email is in list as (logical "delete"), then we need to remove that  entry
                 and add new entry with disposition based on whether or not its in the contact list */
            
              /* if email is already in list as deleted (means user deleted entry in this session and wants to add person back in). 
                 If that is the case, delete that entry, then add new to front of list array below*/
              let disposition = 'new';
              if (this.isEmailInListAsDeleted(this.state.emailValue)) {  
                console.log(`Participant ${this.state.emailValue} is in list as deleted `)
                /* delete item */ 
                let idx = participantsCopy.findIndex(participant => participant.email === this.state.emailValue)
                participantsCopy.splice(idx, 1);
                console.log(`This is index value found as deleted `, idx )           
                /* set disposition based on whether user is in contact list or not.  */
                disposition = addToContacts === 'yes' ? 'existing' : 'new'; 
              }
              /* add entry to the front of the array */
              participantsCopy.unshift({
                email: this.state.emailValue, 
                name:  firstName + ' ' + lastName,
                sentDate: null, 
                attend: '',
                disposition, 
                addToContacts
              });
              
              /* if disposition is new and addToContacts is yes, then add to contacts list on redux store*/
              if (disposition === "new" && addToContacts === "yes") {
                this.addToContactsOnReduxStore(this.state.emailValue, this.state.nameValue);
              }
          }
          
          /* Update list on redux store */
          this.props.updateParticipants(participantsCopy);

          /* construct object needed to add participant to database */
          // let newParticipant = 
          // {
          //   organizerEmail: this.props.auth.user.email,
          //   event_id:   activeEvent._id,
          //   email: this.state.emailValue,
          //   name:  firstName + ' ' + lastName,
          //   addToContacts
          // }

          /* in addition to passing object above to udpate database, pass participantsCopy
             so upon successful add of new partcipant, we update the redux store with new participant list.*/ 
          // this.props.startAddNewParticipant(newParticipant, participantsCopy);

          /* and clear local state values */
          this.setState({
            emailValue: '',
            nameValue: '',
            sentdate: '',
            editIndex: 0,
            editParticipant: false
          })

          //clear both input fields in the child component (PicContactsAutoSuggest)
          // this.state.childFunction('both');

          /* clear the editParticipant flag and index value*/

      } else { 
        this.displayError(); 
      }
    };

    // The way the delete works is it creates a new array with only the keepers (excludes the deletes).
    // It then replaces the entire array in the database with keepers list, if DB update is successful, 
    // it then replaces entire array in the local storage. Afterwards it clears picapp.error and 
    //  formError (if any), and clears checkAll flag (event that was selected)
    // handleDeleteParticipant = () => {
      
    //   /* create new array with only the keepers (excludes participant(s) deleted)  */
    //   let keepers       = this.props.participants.list.filter(participant => !participant.isChecked);
    //   let contactDeleteList    = this.props.participants.list
    //                            .filter(participant =>  participant.isChecked)
    //                            .map(participant =>  participant.email);
                                        

    //   /* if lengths are equal, nothing was deleted */
    //   if (keepers.length === this.props.participants.list.length) {
    //     this.setState({formError: "Letting you know: no selections were made; please select entries before clicking delete:yes"});
    //   } else {  /* one or more participants were selected */

    //     /* construct object used to delete participant(s) */
    //     let participantsDeleteObj = {
    //         event_id: this.props.event.active._id,
    //         organizerEmail: this.props.auth.user.email,
    //         participantList: keepers,
    //         contactDeleteList 
    //     }
    //     /* dispatch action to updateParticipants */
    //     this.props.startDeleteParticipants(participantsDeleteObj);
    //     // this.props.updateParticipants(keepers);
    //     /* if user previously tried to delete without a selection, a warning msg
    //      will display. This is good time to clear it. */
    //     this.setState({participants: keepers,
    //                    formError: '',
    //                    checkAll: false
    //              });
    //   }
    // }

    // This allows user to 'X' out message, after message pops up letting user know
    // they requested an action (eg delete, send mail) but did not select any participants.
    handleClearFormError = () => {
      this.setState({formError: ''})
    }

    /* clearCheckList: Helper function used by handleSendInvites to clear the check marks and update 
       sentdate after email has been sent */
    // clearCheckList = (theList, updateSentDate = true) => {
    //   let copyOfList = [...theList];
    //   // let sentDate = new Date().toISOString();
    //   let sentDate = new Date();
    //   // sentDate = format(sentDate, 'MM/dd/YY');
    //   if (updateSentDate) {
    //     copyOfList.forEach( (participant) => {
    //         if (participant.isChecked === true) {
    //             participant.isChecked = false;
    //             participant.sentdate = sentDate;
    //         } 
    //     })  
    //   }
    //   if (!updateSentDate) { 
    //       copyOfList.forEach( participant => participant.isChecked = false ) 
    //   }

    //   this.props.updateParticipants(copyOfList);          /* update state with new copy of array  */
    //   this.setState({checkAll: false});  /* clear the checkAll flag */
    //   return copyOfList;
    // }

    handleOnClickBackButton = (e) => {  
      e.preventDefault();

      /* route user to PicInvitation Page */
      history.push('/eventmanage/event');
    }

    /* This button is used to do a save in place. It applies all the changes made to redux store to database. 
       Upon succesful completion, it cleans up deletes and sets everything remaining entries in redux store
       to existing and updates contact list with new adds or deletes  */
    handleSavePeopleEntries = (e) => {
      e.preventDefault();
      let participantList = this.props.participants.list;
      let nextScreen = "none";
      this.props.startUpdateParticipantList(participantList, nextScreen);
    }

    /* This same as handleSavePeopleEntries but instead of save in place, it saves and moves to next screen.  */
    handleSaveAndNext = (e) => {
      e.preventDefault();
      let nextScreen =  "/eventmanage/lists";
      let participantList = this.props.participants.list;
      this.props.startUpdateParticipantList(participantList, nextScreen);
    }

    // ****************************************************************** */
    // Utility / Helper methods.
    // ****************************************************************** */

    isFormValidated = () => {
      // console.log(`>>> VALIDATION : FIELDS ARE: email: ${this.state.emailValue}  name: ${this.state.nameValue}`)

      let valid = false;
      let { emailValue, nameValue } = this.state;

      if (!emailValue &&  !nameValue) {
          this.setState(() => ({ formError: 'Missing entry: Please enter email and name:yes'}))
      } else 
      if (!emailValue && nameValue) {
          this.setState(() => ({ formError: 'Missing entry: Please enter email:yes '}));
      } else 
      if (emailValue && !nameValue) {
            this.setState(() => ({ formError: 'Missing entry: Please enter name:yes'}));
      } else 
      if (emailValue.length > 50) {
        this.setState(() => ({ formError: 'Too Many Characters: Sorry! you may only enter 50 characters in the email:yes'}));
      } else 
      if (nameValue.length > 32) {
          this.setState(() => ({ formError: 'Too Many Characters: Sorry! you may only enter 32 characters for the name:yes'}));
      } else 
      if (!isEmail(emailValue) ) {
              this.setState(() => ({ formError: 'Something wrong: email address is not properly formatted:yes'}));
      } else 
      if (this.isDuplicateParticipant() ) {
              this.setState(() => ({ formError: `Letting you know: '${this.state.emailValue}' has already been added:yes`}));
      } else 
      if (nameValue.trim() === '') {  /* if nameValue passed prior validations, it more than likely is white spaces */
          // clear the 
          // console.log(`This is nameValue before setState |${this.state.nameValue}|`)
          
          this.setState(
            { formError: 'Missing something: Please enter name:no ' },
            () => {this.displayError(); 
                  // console.log(`This is nameValue after setState |${this.state.nameValue}|`)
                  this.state.childFunction('name'); // clear name input field in child component
                }  
          )
      } else {
        this.setState(() => ({ formError: ''}));
        valid = true;
        return valid;
      }
    }
    
    /* used by isFormValid to avoid adding duplicates */
    isDuplicateParticipant = () => {
      let emailEntered = this.state.emailValue;
      if (!this.props.participants.list || this.state.editParticipant === true) return false;
      return this.props.participants.list.find(function(participant) {
                return  participant.email === emailEntered && participant.disposition !== "delete"
             })
    };

    isEmailInListAsDeleted = (email) => {
      let participantList = this.props.participants.list;
      let foundIdx = participantList.findIndex(participant => participant.email === email && participant.disposition === "delete");
      return foundIdx === -1 ? false : true;
    }
    
    /* used by handleAddNewParticipant , to see if participant already in contacts */
    existInContacts = (email) => {
      let contacts = this.props.contacts.list;
      let index = contacts.findIndex(contact => contact.email === email)
      return index > -1 ? true : false;
    }

    addToContactsOnReduxStore = (email, name )  => {
      let copyOfContactsList = this.props.contacts.list;
      copyOfContactsList.push({email, name});
      this.props.updateContacts(copyOfContactsList);

    }


    /* primary sort function */
    sortBy = (key) => {
      /* flip sort order flag (on local state) for key being used for sort */
      // console.log(`>>> SORTBY key value is "${key}"`);
      // console.log(`    current sort flag is "${this.state.emailSortAsc}"`);
      
      if (key === 'email') {
        this.setState(
          {emailSortAsc: !this.state.emailSortAsc},
          () => {sort()}
        )
      } else
      if (key === 'name')  {
        this.setState(
          {nameSortAsc: !this.state.nameSortAsc},
          () => {sort()}
        )
      } else 
      if (key === 'sortabledate') {
        this.setState(
          {dateSortAsc: !this.state.dateSortAsc},
          () => {sort()}
        )
      }

      let sort = () => {
        let arrayCopy = [...this.props.participants.list];
        arrayCopy.sort(this.compareBy(key));
        // this.setState({participants: arrayCopy});
        this.props.updateParticipants(arrayCopy);
      }
    } 

    // SortBy support function
    // inputs: function parameters: possible key values are: email, name, or sentdate
    //         local state: this function uses the emailSortAsc flag to check whether sort is Asc, if not,
    //                      it sorts in descending order. 
    compareBy = (key) => {
      // console.log(`>>> COMPAREBY  key value is "${key}"`);
      let sortAsc = '';
      if (key === 'email') {
        sortAsc = this.state.emailSortAsc;
        // console.log(`     key value was email`)
      } 
      if (key === 'name') {
        sortAsc = this.state.nameSortAsc;
        // console.log(`     key value was name`)
      }
      if (key === 'sortabledate') {
        sortAsc = this.state.dateSortAsc;
        // console.log(`     key value was sentdate`)
      }
      
      // console.log(`    sortAsc flat set in function is  "${sortAsc}"`);

      /* sort ascending or descending based on current sort order flag */
      if ((key === 'email' || key === 'name') && (sortAsc === true)) {
        // console.log(`    currently sorting ASCENDING`);
        return function (a, b) {
            if (a[key].toLowerCase() < b[key].toLowerCase()) return -1;
            if (a[key].toLowerCase() > b[key].toLowerCase()) return 1;
          return 0;
        };
      } else 
      if ((key === 'email' || key === 'name') && (sortAsc === false)) {
        // console.log(`    currently sorting DESCENDING`);
        return function (a, b) {
            if (a[key].toLowerCase() > b[key].toLowerCase()) return -1;
            if (a[key].toLowerCase() < b[key].toLowerCase()) return 1;
        }
      } else if ((key === 'sortabledate')  && (sortAsc === true)) {
        // console.log(`    sorting date ASCENDING`);
        return function (a, b) {
          return a.sortabledate - b.sortabledate;
        }
      } else if ((key === 'sortabledate')  && (sortAsc === false)) {
        // console.log(`    sorting date DESCENDING`);
        return function (a, b) {
          return b.sortabledate - a.sortabledate ;
        }
      } else { /* do nothing */}
    }

    displayError = (withCloseOption) => {
        let error = this.state.formError || this.props.picapp.error || '';

        if (error) {
            // Split message
            let messageArray = error.split(':');
            let [ messageLabel, message, closeoption ] =  messageArray;
            // Return message JSX
            return  <div className="invites-pic-error ">
                      <div>
                        <FontAwesomeIcon className="warning-icon" icon={faExclamationTriangle} />
                        <span className="pic-err-msg-label">{`${messageLabel}: `}</span>
                        <span className="pic-err-msg">{message}</span>
                      </div>
                      {closeoption === 'yes' && <div className="error-close" onClick={this.handleClearFormError}>X</div>}
                    </div>
        } else {
            return <p className="pic-error-filler">&nbsp;</p>
        }
    }

    /* This handler will load participant into the inputbar for user to edit. It also 
       saves current values as prevEmail, prevName, prevDisposition so addNewparticipant can compare
       previous values (namely email) with changed value to take appropriate action on contacts
       See comments on . */
    handleEditItem = (email) => {

      console.log("INSIDE HANDLE EDIT ITEM");
      let participantList = this.props.participants.list;
      console.log("This is participantList ", JSON.stringify(participantList,null,2));

      /* find index for this email address */
      let idx = participantList.findIndex( participant => participant.email === email);
      console.log("This is person selected ", JSON.stringify(participantList[idx],null,2));

      console.log(" -- (v) email ", email)
      console.log(" -- (v) name  ", participantList[idx].name)
      console.log(" -- (v) disposition  ", participantList[idx].disposition)

      /* set the edit flags and save current as previous values */
      this.setState({ emailValue: email, nameValue: participantList[idx].name, 
                      prevEmailValue: email, prevNameValue: participantList[idx].name, prevDisposition: participantList[idx].disposition,
                      editParticipant: true, editIndex: idx 
      });
    }

    handleDeleteItem = (email) => {
      console.log("HANDLE DELETE ITEM FOR ", email);

        /* make copy of participants array*/
        let participantsCopy = []; 
        if (this.props.participants.list) {  
          participantsCopy = [...this.props.participants.list];
        } 

        /* find index value  for this email address */
       let idx =  participantsCopy.findIndex(participant => participant.email === email)

        /* set disposition for item at idx to delete */
        let participant = participantsCopy[idx];
        participant.disposition = "delete";

        /* update redux store with modified list (deleted entry) */
        this.props.updateParticipants(participantsCopy);
    }

    handleOnClickHomeIcon = () => {
        history.push("/dashboard");
    }

    // ****************************************************************** */
    // Column renderers
    // ****************************************************************** */ 

    // JSX used to construct a row; 
    inviteRow = ({email, name, idx}) => (
      <div className="people-row" key={email}>
          <div className="pcol01">
              <div className="invites-header-col1-spacer"> &nbsp;</div>
          </div>
          <div className="pcol02">{email}</div>
          <div className="pcol03">{name}</div>
          <div className="pcol04">{this.bindActionIconsToEmail(email)}</div>
      </div>
    );

    /* As the method says, this is used to return the action items Jsx while making sure the
     on click event handlers are bound to the correct index entry */ 
    bindActionIconsToEmail = (email) => {
      return (
        <div className="pic-lists-col3" key="3" >
          <div onClick={ this.handleEditItem.bind(this, email) } className="pencil-icon-button">
            <PencilIcon color="grey" size="small" />
          </div>     
          <div onClick={ this.handleDeleteItem.bind(this,email)} className="trash-icon-button">
            <TrashIcon color="grey" size="small" />
          </div>     
        </div>
      )
    }

    // ****************************************************************** */
    // render method
    // ****************************************************************** */ 
    render() {
      // Initialize event title; If no event is selected, do not show the literal "for" or a title.
      let  eventTitle = "List of People ";
      
      // If there is an active event, concat 
      let { active: activeEvent  } = this.props.event;
      if (!isEmpty(activeEvent)) {
          eventTitle   = eventTitle + " for " + activeEvent.eventTitle;
      }
      // If there are participants for that selected event, set participants to non-deleted entries, otherwise default to empty
      let participants = [];
      if (this.props.participants) { 
         participants  = this.props.participants.list.filter(participant => participant.disposition !== "delete");  
      }

      const rows = participants.map( (rowData, idx) => {
         return    this.inviteRow({...rowData, idx})
      });

      return (
        <div className="tab-selection-panel">
          <div className="invites-table-container">
              <div className="invites-error-container" >
              {this.displayError()} 
     
              <Title text={eventTitle} />
     
              </div>
              <div className="people-input-row-maxheight" >
                <div className="people-input-row">
                    <div className="col02-03">
                        <PicContactsAutoSuggest  
                            setParentComponentValues={this.setParentComponentValues} 
                            getChildFunction={this.getChildFunction} 
                            emailValue={this.state.emailValue}
                            nameValue={this.state.nameValue}
                            onChangeField1Handler={this.onChangeField1Handler}
                            onChangeField2Handler={this.onChangeField2Handler}
                        />
                    </div>
                    <button onClick={this.handleAddNewParticipant} className="tiny-plus-button" >
                        <div className="tiny-plus-icon">+</div>
                    </button>
                </div>
              </div>
                <div className="people-header">
                    <InviteCheckBoxHeader 
                        checked={this.state.checkAll} 
                        handler={this.handleCheckBoxAll}
                    /> 
                    <div className="pcol02" onClick={() => this.sortBy('email')} >Email Address</div>
                    <div className="pcol03" onClick={() => this.sortBy('name')}>Name</div>
                    <div className="pcol04"></div>
                </div> 
              <div className="people-table">
                {participants.length === 0 ? (
                  <div>
                    <p className="invites-noparticipants-msg1">Add people by entering email and name above, then click plus sign.</p>
                    <p className="invites-noparticipants-msg2"></p>
                  </div>
                ) : (
                  <div>
                    {rows}
                  </div>
                )}
              </div>
              <hr className="line-separator" />
              <div className="invites-buttons-container">
                <div className="eventinfo-back-button-container">
                    <ShadowButton  buttonText="Back" words={1} onClickHandler={this.handleOnClickBackButton} />
                    <div className='eventinfo-modifier-plr1' >
                       <div onClick={this.handleOnClickHomeIcon}><HomeIcon /></div>
                    </div>
                </div>
                <div className="invite-right-buttons-container">
                    <ShadowButton buttonText="Save" words={1} onClickHandler={this.handleSavePeopleEntries} />
                    <div>&nbsp;</div>
                    <SimpleButton buttonText="Save / Next" words={2} onClickHandler={this.handleSaveAndNext} />
                </div>
              </div>
              <div className="show-for-mobile rc-horiz-spacer-tiny-minus">&nbsp;</div>
          </div>
      </div>
      );
    }
} /* Component (PicInvites) end */ 
  

const mapStateToProps = (state) => {
    return {
        auth:   state.auth,
        picapp: state.picapp,
        event:  state.event,
        participants:  state.participants,
        contacts: state.contacts
    };
};

const mapDispatchToProps = (dispatch) => ({
    clearPicAppError:       () => dispatch(clearPicAppError()),
    startGetParticipants:   (fromPage) => dispatch(startGetParticipants(fromPage)),
    startAddNewParticipant: (newParticipant, participantsCopy) => dispatch(startAddNewParticipant(newParticipant, participantsCopy)),
    startDeleteParticipants: (participantsArray) => dispatch(startDeleteParticipants(participantsArray)),
    startUpdateParticipantList: (participantList, nextScreen) => dispatch(startUpdateParticipantList(participantList, nextScreen)),
    updateParticipants:     (participants) => dispatch(updateParticipants(participants)),
    updateContacts:         (contacts) => dispatch(updateContacts(contacts))
});

export default connect(mapStateToProps, mapDispatchToProps)(PicPeople);


// WEBPACK FOOTER //
// ./src/components/PicPeople.js